import React, { Component } from 'react';

class Undefined extends Component {
  render() {
    return (
      <></>
    );
  }
}
export default Undefined;